import * as api from "@/api/williams/testEvents";
import { getFullPath, routes } from "../../routes";
import { getTestEventStatus } from "../lookup/status";
import { queryKeys } from "../../queryKeys";
import { TestEvent } from "@/api/williams/testEvents";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router";
import { usePinTestEvent } from "./usePinTestEvent";

export function useSaveTestEvent() {
  const queryClient = useQueryClient();
  const pinEvent = usePinTestEvent();
  const navigate = useNavigate();

  return useMutation(async (event: TestEvent) => {
    cleanupTestResults(event);
    event.status = getTestEventStatus(event);

    const response = await api.saveTestEvent(event);
    const updatedEvent = transform(response);

    updateCache(updatedEvent);

    if (window.location.href.endsWith(routes.testEvent.create)) {
      // Automatically add new events to favorites.
      pinEvent.mutate(updatedEvent.id);
      redirect(updatedEvent);
    }

    return updatedEvent;
  });

  function updateCache(event: TestEvent) {
    queryClient.setQueryData(queryKeys.testEvent.single(event.id), event);
    queryClient.removeQueries(queryKeys.testEvent.results(event.id));
    queryClient.invalidateQueries(queryKeys.testEvent.list());
  }

  function redirect(event: TestEvent) {
    // Redirect from /new to the actual created event.
    navigate(getFullPath(routes.testEvent.open(event.id)), {
      replace: true,
      state: {
        skipSavePrompt: true,
      },
    });
  }

  function cleanupTestResults(event: TestEvent) {
    // Remove lingering test results where the welder/test has been removed.
    event.welderTests = event.welderTests.filter(
      (result) =>
        event.tests.some((test) => test.recordId === result.templateId) &&
        event.welders.some((welder) => welder.welderId === result.welderId)
    );
  }

  function transform(event: TestEvent) {
    return {
      ...event,
      // Remove time portion so it works with the HTML date input.
      testEventDate: event.testEventDate?.substring(0, 10),
    };
  }
}
